<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="w-full flex flex-col items-center px-6 lg:px-0 py-10 lg:py-14 col-span-full md:col-start-2 lg:col-start-4 md:col-end-8 lg:col-end-10"
    >
      <p
        class="text-3xl lg:text-5xl px-4 text-center lg:text-left"
        v-text="'Lorem ipsum dolor sit amet consectetur adipiscing elit'"
      />
      <p
        class="pt-9 text-xl px-4 text-center lg:text-left"
        v-text="
          `Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since`
        "
      />
      <section class="pt-7">
        <section class="grid lg:grid-cols-2 py-2.5 gap-y-5 gap-x-8">
          <input-field
            identity="firstName"
            ref="firstName"
            placeholder="Nombre"
            v-model="contactData.firstName"
            :rules="{
              required: true,
            }"
          />
          <input-field
            identity="lastName"
            ref="lastName"
            placeholder="Apellidos"
            v-model="contactData.lastName"
            :rules="{
              required: true,
            }"
          />
          <input-field
            identity="phone"
            ref="phone"
            placeholder="Teléfono"
            v-model="contactData.phone"
            :rules="{
              required: true,
              numeric: true,
            }"
          />
          <input-field
            identity="email"
            ref="email"
            placeholder="Correo electrónico"
            v-model="contactData.email"
            :rules="{
              required: true,
              email: true,
            }"
          />
        </section>
        <section class="flex justify-center pt-3.5">
          <main-button />
        </section>
      </section>
    </section>
  </section>
</template>
<script>
export default {
  components: {
    InputField: () => import("../components/InputField.vue"),
    MainButton: () => import("../components/MainButton.vue")
  },
  data: () => ({
    contactData: {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
    },
  }),
  props:{
    withBorder:{
      default: true
    }
  }
};
</script>
